<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <SecondaryButton
          v-if="params.context.parentComponent.permissions.view"
          @click="viewTicket"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-eye"
          iconClass=""
        >
        </SecondaryButton>
      </template>
      <span>View Ticket Details</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <WarningButton
          @click="sendReminderNotification"
          v-if="
            params.context.parentComponent.permissions.view &&
            params.data.is_resolution_time_expired
          "
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="rounded"
          icon="mdi-bell"
          iconClass=""
        >
          <v-icon x-small color="white"> mdi-bell </v-icon>
        </WarningButton>
      </template>
      <span>Remainder</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    sendReminderNotification() {
      this.params.context.parentComponent.setRemainder(this.params.data.id);
    },
    viewTicket() {
      this.$router.push({
        name: "ticket-view",
        params: {
          id: this.params.data.id,
        },
      });
    },
  },
};
</script>
